import axios from 'axios'
import { CATALOGO_ENDPOINT } from 'common/endpoints'

export async function saveFastStockLoadingData(saveData) {
  const response = await axios.post(
    `${CATALOGO_ENDPOINT}/?fast_stock_loading=true`,
    {...saveData}
  )
  return response.data
}